module.exports = __webpack_public_path__ + "static/media/QRCodeError.16ab8aa5.svg";